import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FeaturedEventsService {

  constructor(private http: HttpClient) { }

    /**
     * Get all featured events
     */
    getAllFeaturedEvents() {
        return this.http.get<any>('api_endpoint' + `/featured-events`);
    }

    /**
     * Get single featured events
     */
    getSingleFeaturedEvent(featuredEventsId) {
        return this.http.get<any>('api_endpoint' + `/featured-events/${featuredEventsId}`);
    }

    /**
     * Get all featured events
     */
    deleteSingleFeaturedEvent(featuredEventsId) {
        return this.http.delete<any>('api_endpoint' + `/featured-events/delete/${featuredEventsId}`);
    }

    /**
     * Get all ties
     */
    createFeaturedEvent(data) {
        return this.http.post<any>('api_endpoint' + '/featured-events/create', { data });
    }
}
